<template>
    <div id="pagination-component" ref="pagination-component">
        <ul>
            <li>
                <a href="#" v-on:click="first" title="Primeira página">
                    <picture>
                        <source :srcset="url + '/img/seta_1.webp'" type="image/webp">
                        <source :srcset="$url + 'img/seta_1.png'" type="image/png"> 
                        <img alt="Primeira página" style="transform: rotate(90deg)" :src="url + '/img/seta_1.webp'">
                    </picture>
                    <picture>
                        <source :srcset="url + '/img/seta_1.webp'" type="image/webp">
                        <source :srcset="$url + 'img/seta_1.png'" type="image/png"> 
                        <img alt="Primeira página" style="transform: rotate(90deg);margin-left: -14px" :src="url + '/img/seta_1.webp'">
                    </picture>
                </a>
            </li>
            <li>
                <a href="#" v-on:click="prev" title="Página anterior">
                    <picture>
                        <source :srcset="url + '/img/seta_1.webp'" type="image/webp">
                        <source :srcset="$url + 'img/seta_1.png'" type="image/png"> 
                        <img alt="Página anterior" style="transform: rotate(90deg)" :src="url + '/img/seta_1.webp'">
                    </picture>
                </a>
            </li>
            <li v-for="(o, key) in pages" v-bind:key="key">
                <a href="#" v-bind:class="{ active: o.active }" v-on:click="pageHandler">{{ o.o }}</a>
            </li>

            <li>
                <a href="#" v-on:click="next" title="Próxima página">
                    <picture>
                        <source :srcset="url + '/img/seta_1.webp'" type="image/webp">
                        <source :srcset="$url + 'img/seta_1.png'" type="image/png"> 
                        <img alt="Próxima página" style="transform: rotate(270deg)" :src="url + '/img/seta_1.webp'">
                    </picture>
                </a>
            </li>
            <li>
                <a href="#" v-on:click="last" title="Última página">
                    <picture>
                        <source :srcset="url + '/img/seta_1.webp'" type="image/webp">
                        <source :srcset="$url + 'img/seta_1.png'" type="image/png"> 
                        <img alt="Última página" style="transform: rotate(270deg)" :src="url + '/img/seta_1.webp'">
                    </picture>
                    <picture>
                        <source :srcset="url + '/img/seta_1.webp'" type="image/webp">
                        <source :srcset="$url + 'img/seta_1.png'" type="image/png"> 
                        <img alt="Última página" style="transform: rotate(270deg);margin-left: -14px" :src="url + '/img/seta_1.webp'">
                    </picture>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "PaginationComponent",
        props: ['pag', 'total'],
        data() {
            return {
                init   : false,
                list_n : 10,//resultados por página
                n_temp : 0,
                pag_max: 5,
                pages  : null,
                p      : 0,
                p_final: 0,
                url    : this.$url
            }
        },
        methods: {
            algorithm(current, {min = 1, length = this.pag_max} = {}) {
                if (length > this.p_final) length = this.p_final;
                let start = current - Math.floor(length / 2);
                start = Math.max(start, min);
                start = Math.min(start, min + this.p_final - length);
                return Array.from({ length: length }, (el, i) => start + i);
            },
            processing() {
                this.pages = [];
                let ar = this.algorithm(this.p + 1);
                for (let n = 0; n < ar.length; n++) {
                    this.pages.push({ active:(ar[n] == (this.p + 1)), o:ar[n] });
                }

                if (this.init) {
                    console.log('init');
                    history.pushState({ page: this.p }, "", "?page=" + this.p);
                    this.$parent.pageHandler(this.p);
                }

                this.init = true;
            },
            pageHandler(e) {
                this.p = Number(e.currentTarget.innerHTML) - 1;
                this.processing();

                e.preventDefault();
            },
            prev(e) {
                if (this.p > 0) {
                    this.p--;
                    this.processing();
                }
                e.preventDefault();
            },
            next(e) {
                if (this.p < (this.p_final - 1)) {
                    this.p++;
                    this.processing();
                }
                e.preventDefault();
            },
            first(e) {
                if (this.p > 0) {
                    this.p = 0;
                    this.processing();
                }
                e.preventDefault();
            },
            last(e) {
                if (this.p < (this.p_final - 1)) {
                    this.p = this.p_final - 1;
                    this.processing();
                }
                e.preventDefault();
            },
            restart(obj) {
                console.log('restart');
                this.init    = false;
                this.p       = 0;
                this.p_final = Math.ceil(obj.total / this.list_n);
                this.processing();
            }
        },
        mounted() {
            this.p = Number(new URL(window.location.href).searchParams.get("page"));
            this.p_final = Math.ceil(this.total / this.list_n);
            this.processing();
            //this.$parent.pageHandler(this.p);
            this.pag.$on('restart', this.restart);
        }
    }
</script>
<style scoped>
    @import "../assets/css/pagination.css";
</style>
